export default {
    home: {
        title: 'ร้านค้าเกม'
    },
    list: {
        title: 'ร้านค้า',
        select_option: 'เลือกตัวเลือก',
        more: 'เพิ่มเติม',
        less: 'น้อยลง',
    },
    detail : {
        title: 'กรอกข้อมูล',
        game_info: 'ข้อมูลเกม',
        price: 'ราคา',
        unit: 'ชิ้น',
        total: 'ยอดรวมทั้งหมด',
        total_point: 'คะแนนที่ได้รับ',
        point: 'คะแนน',
        next: 'ต่อไป',
        fill: 'กรอก',
        select: 'เลือก',
        please_select: 'กรุณาเลือก ',
        please_enter: 'กรุณากรอก ',
    }
}
